import { ShiftCategory } from "src/api/workers";
import { WhoCalledRatingPerformanceModal } from "@src/appV2/components/BlockWorkersAndGetDonuts/constants";
import { HCF_USER_EVENTS } from "src/constants/firebaseEvents";
import { logEvent } from "@src/appV2/lib/analytics";
import { ShiftDetailsType } from "./WorkerDetails/workplaceWorker.types";

export type ActiveTab = "upcoming" | "inProgress" | "past" | "allProfessionals";

export function getActiveTabName(activeTab: ShiftDetailsType | ShiftCategory): ActiveTab {
  switch (activeTab) {
    case ShiftDetailsType.INPROGRESS:
    case ShiftCategory.IN_PROGRESS:
      return "inProgress";

    case ShiftDetailsType.UPCOMING:
    case ShiftCategory.UPCOMING:
      return "upcoming";

    case ShiftDetailsType.PAST:
    case ShiftCategory.PAST:
      return "past";
  }
}

type CommonLogData = {
  workerId: string;
  workplaceId: string;
  workplaceUserId: string;
  activeTab?: ActiveTab;
  // we should standardize the location
  location: typeof WhoCalledRatingPerformanceModal[keyof typeof WhoCalledRatingPerformanceModal];
};

export function logViewDocument({
  workerId,
  workplaceId,
  workplaceUserId,
  activeTab,
  location,
}: CommonLogData) {
  logEvent(HCF_USER_EVENTS.VIEW_DOCUMENT, {
    workerId,
    workplaceId,
    workplaceUserId,
    activeTab,
    location,
  });
}

export function logProfileNavigated({
  workerId,
  workplaceId,
  workplaceUserId,
  location,
  activeTab,
  shiftId,
}: CommonLogData & { shiftId?: string }) {
  logEvent(HCF_USER_EVENTS.WORKER_PROFILE_NAVIGATED, {
    workerId,
    workplaceId,
    workplaceUserId,
    location,
    activeTab,
    shiftId,
  });
}
